import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tooltip, Alert } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { ButtonItem, ModalItem } from "./Items";
import RackMapaGrid from "../Pages/Panel/Ubicaciones/MapaWms/RackMapaGrid";
import { construirSvgMiniRack, posicionRackTexto } from "./miniMapaRack";

const LIMITE_GRID = 10;

const cacheDetalleRack = new Map();
const consultarDetalleRack = (empresaId, headersToken, proyectoId, rackId) => {
  const llave = `${empresaId}_${proyectoId}_${rackId}`;
  if (!cacheDetalleRack.has(llave)) {
    cacheDetalleRack.set(
      llave,
      axios
        .post("rack/selectDetalleRackConInsumos", { empresaId, proyectoId, rackId }, { headers: headersToken })
        .then((res) => (res.data.success === 2 ? { rack: res.data.rack, ubicaciones: res.data.ubicaciones } : null))
        .catch(() => null)
    );
  }
  return cacheDetalleRack.get(llave);
};

const PosicionRackButton = ({ empresaId, headersToken, proyectoId, insumo }) => {
  const [visible, setVisible] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [detalle, setDetalle] = useState(null);

  const puedeFetch = !!(empresaId && proyectoId && headersToken && insumo?.rackId);

  useEffect(() => {
    if (!visible || !puedeFetch || detalle) return;
    setCargando(true);
    consultarDetalleRack(empresaId, headersToken, proyectoId, insumo.rackId).then((valorDetalle) => {
      setDetalle(valorDetalle);
      setCargando(false);
    });
  }, [visible, puedeFetch, empresaId, headersToken, proyectoId, insumo?.rackId, detalle]);

  const etiqueta = posicionRackTexto(insumo);
  if (!insumo?.rackId) return null;

  const rack = detalle?.rack;
  const esGrande = rack && (rack.numeroColumnas > LIMITE_GRID || rack.numeroNiveles > LIMITE_GRID);
  const mostrarGridReal = puedeFetch && rack && !esGrande;

  const ubicacionDestacada = detalle?.ubicaciones?.find((u) => String(u._id) === String(insumo.ubicacionId));
  const datosSvg = esGrande
    ? { numeroColumnas: rack.numeroColumnas, numeroNiveles: rack.numeroNiveles, columna: ubicacionDestacada?.columna ?? insumo.columna, nivelRack: ubicacionDestacada?.nivelRack ?? insumo.nivelRack }
    : { numeroColumnas: insumo.rackNumeroColumnas, numeroNiveles: insumo.rackNumeroNiveles, columna: insumo.columna, nivelRack: insumo.nivelRack };

  return (
    <>
      <Tooltip title="Ver posición en el rack">
        <ButtonItem size="small" cyan icon={<EnvironmentOutlined />} onClick={() => setVisible(true)} />
      </Tooltip>
      <ModalItem
        title={`Posición en el rack${insumo.rackCodigo || rack?.codigo ? ` — ${insumo.rackCodigo || rack.codigo}` : ""}`}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={mostrarGridReal ? 900 : 380}
        spinning={cargando}
      >
        {mostrarGridReal ? (
          <div style={{ maxHeight: "70vh", overflow: "auto" }}>
            <RackMapaGrid
              rack={rack}
              ubicaciones={detalle.ubicaciones}
              puedeModificar={false}
              ubicacionesDestacadasIds={[insumo.ubicacionId]}
              profundidadInicial={insumo.profundidad}
            />
          </div>
        ) : (
          <>
            {esGrande && (
              <Alert type="info" showIcon style={{ marginBottom: 8 }} message={`Rack grande (${rack.numeroColumnas}×${rack.numeroNiveles}) — vista simplificada`} />
            )}
            {datosSvg.numeroColumnas > 0 && datosSvg.numeroNiveles > 0 && (
              <div style={{ display: "flex", justifyContent: "center" }} dangerouslySetInnerHTML={{ __html: construirSvgMiniRack(datosSvg) }} />
            )}
            {etiqueta && <div style={{ textAlign: "center", fontSize: 12, color: "#4b5563", marginTop: 6 }}>{etiqueta}</div>}
          </>
        )}
      </ModalItem>
    </>
  );
};

export default PosicionRackButton;
